import React from 'react';
import { MessageSquarePlus } from 'lucide-react';
import { useSurvey } from '../../contexts/SurveyContext';

/**
 * Circular button (placed to the left of Sign out) that re-opens the latest
 * active survey. Renders nothing when there is no active survey to take.
 */
const SurveyButton: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { hasActiveSurvey, openSurvey } = useSurvey();

  if (!hasActiveSurvey) return null;

  return (
    <button
      onClick={openSurvey}
      aria-label="Open survey"
      title="We'd love your feedback"
      className={`relative flex items-center justify-center w-10 h-10 rounded-full border border-gray-200 hover:bg-gray-100 transition-colors ${className}`}
    >
      <MessageSquarePlus size={18} className="text-black" />
      <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-red-500 rounded-full ring-2 ring-white" />
    </button>
  );
};

export default SurveyButton;
